import UnlockIcon from "../../images/unlock-icon-toolbar.svg";
import LockIcon from "../../images/lock-icon-toolbar.svg";

export function aspectRatioCheckBoxHandler(isLocked) {
  const aspect = document.querySelector(".gjs-field-wrp--checkbox");
  if (aspect && isLocked) {
    aspect?.classList?.remove("aspect-unlocked");
    aspect?.classList?.add("aspect-locked");
  } else {
    aspect?.classList?.remove("aspect-locked");
    aspect?.classList?.add("aspect-unlocked");
  }
}

// export function toggleResizable() {
//   const isLocked = this.get("lockAspectRatio");
//   const toolbar = this.get("toolbar") || [];

//   const updatedToolbar = toolbar.map((item) => {
//     if (item.command === "toggle-aspect") {
//       return {
//         ...item,
//         label: isLocked
//           ? `<img src="${LockIcon}" style="width:16px;height:16px;" />`
//           : `<img src="${UnlockIcon}" style="width:16px;height:16px;" />`,
//       };
//     }
//     return item;
//   });
//   this.set("toolbar", updatedToolbar);

//   // Update resizable configuration
//   this.updateResizableConfig();
// }

// export function addLockIconToToolbar() {
//   const toolbar = this.get("toolbar") || [];
//   const isLocked = this.get("lockAspectRatio");
//   const hasLockIcon = toolbar.some((t) => t.command === "toggle-aspect");

//   if (!hasLockIcon) {
//     // Enable resizable if not locked
//     if (!isLocked) {
//       this.updateResizableConfig();
//     } else {
//       this.updateResizableConfig();
//     }

//     const lockBtn = {
//       id: "lock-btn",
//       type: "button",
//       command: "toggle-aspect",
//       attributes: {
//         class: "gjs-toolbar-item",
//         title: "Lock Aspect Ratio",
//       },
//       label: isLocked
//         ? `<img src="${LockIcon}" style="width:16px;height:16px;" />`
//         : `<img src="${UnlockIcon}" style="width:16px;height:16px;" />`,
//     };

//     this.set("toolbar", [lockBtn, ...toolbar]);
//   }
// }

// export function updateResizableConfig() {
//   const isLocked = this.get("lockAspectRatio");
//   const aspectRatio = this.get("aspectRatio");

//   if (isLocked && aspectRatio) {
//     this.set("resizable", {
//       tl: 1,
//       tc: 0,
//       tr: 1,
//       cl: 0,
//       cr: 0,
//       bl: 1,
//       bc: 0,
//       br: 1,
//       ratioDefault: true,
//       ratio: aspectRatio,
//     });
//   } else {
//     this.set("resizable", {
//       tl: 1,
//       tc: 1,
//       tr: 1,
//       cl: 1,
//       cr: 1,
//       bl: 1,
//       bc: 1,
//       br: 1,
//       ratioDefault: false,
//     });
//   }
//   // Update toolbar icon based on lock state
//   aspectRatioCheckBoxHandler(isLocked);
// }

// export function calculateAspectRatio() {
//   const src = this.getAttributes().src;
//   if (!src) return;

//   const img = new Image();
//   img.onload = () => {
//     const isLocked = this.get("lockAspectRatio");
//     const aspectRatio = img.naturalWidth / img.naturalHeight;
//     this.set("aspectRatio", aspectRatio);
//     // If aspect ratio is locked, update resizable config
//     if (this.get("lockAspectRatio")) {
//       this.updateResizableConfig();
//     }
//     aspectRatioCheckBoxHandler(isLocked);
//   };
//   img.onerror = () => {
//     // If image fails to load, try to get aspect ratio from element
//     const el = this.getEl();
//     if (el && el.naturalWidth && el.naturalHeight) {
//       const aspectRatio = el.naturalWidth / el.naturalHeight;
//       this.set("aspectRatio", aspectRatio);
//     }
//   };
//   img.src = src;
// }
